import axios from '../request/http';

const Login = {
    // 获取验证码
    getCode() {
        return axios.get("/hemei-admin/login/captcha");
    },
    // 登录
    login(params) {
        return axios.get("/hemei-admin/login/login", {params});
    },
    // 获取角色列表
    adminJurisdiction(params) {
        return axios.get("/hemei-admin/role/getRoleList", {params});
    },
    // 获取管理台信息
    getManageInfo(params) {
        return axios.get("/hemei-admin/admin/getManageInfo", {params});
    },
    // 获取乡村信息
    getVillageInfo(params) {
        return axios.get("/hemei-admin/EC/Dashboard/getVillageInfo", {params});
    },
     // 获取临时 token
     get_sts_token(params) {
        return axios.get("/hemei-admin/base/oss/get_sts_token", { params });
    },
}

export default Login;


// WEBPACK FOOTER //
// ./src/api/Login.js